import script from "./TvaScrollBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TvaScrollBar.vue?vue&type=script&setup=true&lang=js"

import "./TvaScrollBar.vue?vue&type=style&index=0&id=8c5564d2&lang=scss&scoped=true"
import "./TvaScrollBar.vue?vue&type=style&index=1&id=8c5564d2&lang=scss"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c5564d2"]])

export default __exports__